import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getOKRWeightageList, getPerformancePreviewCompetency } from '../services';

const getData = async ({ startTS, endTS, employeeId, formId }) => {
  try {
    const res = await getOKRWeightageList({
      startTS,
      endTS,
      employeeId,
      formId,
    });
    return res;
  } catch (err) {
    console.error('Error fetching goals cascaded view data : ', err);
  }
  return null;
};

export const goalsReviewCascadedViewReactQueryKey = ({ startTS, endTS, employeeId, formId }) => [
  REACT_QUERY_KEYS.ReviewPreviewPerformanceOKRData,
  startTS,
  endTS,
  employeeId,
  formId,
];

export const performancePreviewCompetencyQueryKey = ({ employeeId }) => [
  REACT_QUERY_KEYS.PerformancePreviewCompetencyTable,
  employeeId,
];

export const useReviewPreviewPerformanceGoalsCascadedViewData = ({ startTS, endTS, employeeId, formId }) =>
  useQuery(
    goalsReviewCascadedViewReactQueryKey({
      startTS,
      endTS,
      employeeId,
      formId,
    }),
    () =>
      getData({
        startTS,
        endTS,
        employeeId,
        formId,
      }),
    { enabled: !!(employeeId && endTS) }
  );

export const usePerformancePreviewCompetencyData = ({ employeeId }) =>
  useQuery(
    performancePreviewCompetencyQueryKey({
      employeeId,
    }),
    () =>
      getPerformancePreviewCompetency({
        employeeId,
      })
  );
